import React from 'react';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';
import Cell from './Cell';
var styles = {
  row: {
    height: 1,
    '&:nth-child(even)': {
      backgroundColor: '#e6e6e6'
    }
  }
};

var Row = function Row(props) {
  var renderColumns = function renderColumns() {
    return props.children.map(function (cell, i) {
      return React.createElement(Cell, {
        key: i
      }, cell);
    });
  };

  return React.createElement(TableRow, {
    className: props.classes.row,
    "data-testid": "defiForm-Row"
  }, renderColumns());
};

export default withStyles(styles)(Row);